<template>
  <CustumLabel
    :name="name"
    :label="label"
    :error="touched && error"
    :required="rules && rules.required"
    :hideErrors="hideErrors"
  >
    <InputNumber
      :class="`w-full ${inputclass}`"
      :value="value"
      :placeholder="placeholder"
      :min="rules.min"
      :max="rules.max"
      :prefix="prefix"
      :suffix="suffix"
      :disabled="disabled"
      @change="handleChange"
      @blur="handleBlur"
    />
  </CustumLabel>
</template>

<script>
import validation from '@/services/validation';
import { InputNumber } from 'ant-design-vue';
import CustumLabel from './CustumLabel.vue';

export default {
  components: { CustumLabel, InputNumber },
  props: {
    name: String,
    inputclass: {
      type: String,
      default: '',
    },
    label: String,
    placeholder: String,
    defaultError: String,
    hideErrors: Boolean,
    disabled: Boolean,
    defaultData: String,
    prefix: String,
    suffix: String,
    rules: {
      type: Object,
      default: null,
    },
    isTouched: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      value: null,
      error: null,
      touched: false,
      isValid: false,
    };
  },
  created() {
    if (this.defaultData || this.defaultData === 0) {
      this.value = this.defaultData;
      this.touched = true;
    }
    this.handleValidate();
    this.setInputValues();
  },
  watch: {
    isTouched(val) {
      if (val) {
        this.touched = true;
      }
    },
    defaultError(val) {
      if (val) {
        this.touched = true;
        this.error = val[0].length > 1 ? val[0] : val;
      }
    },
  },
  methods: {
    handleBlur() {
      this.touched = true;
      this.handleValidate();
      this.setInputValues();
    },
    handleChange(val) {
      this.error = null;
      this.value = val;
    },
    handleValidate() {
      const { error, isValid } = validation.validateRules(
        { ...this.rules, number: true },
        this.value,
      );
      this.error = error;
      this.isValid = isValid;
    },
    setInputValues() {
      const isRequired = this.rules && this.rules.required;
      if (!isRequired && !this.value) {
        return;
      }
      this.$emit('setInput', {
        [this.name]: {
          name: this.name,
          value: this.value,
          error: this.error,
          touched: this.touched,
          isValid: this.isValid,
        },
      });
    },
  },
};
</script>
